module.exports = __webpack_public_path__ + "static/media/linkedin.2f4c3792.svg";